import { render, staticRenderFns } from "./SpecialApprovedInvoicesIndex.vue?vue&type=template&id=32a252f0&scoped=true&"
import script from "./SpecialApprovedInvoicesIndex.vue?vue&type=script&lang=js&"
export * from "./SpecialApprovedInvoicesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a252f0",
  null
  
)

export default component.exports